import React, { useEffect } from 'react';
import styles from './ChangingPage.module.scss';
import FormRegisterTwo from '../../components/ui/FormRegisterTwo/FormRegisterTwo';
import useHousingStockHouses from '../../queries/useHousingStockHouses';
import { setCurrentHouse } from '../../store/actions/housingStockActions';
import {
  useHistory,
  useParams,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { useHouseTemplates } from '../../components/ui/HouseRegistrationTypeManager/api/templatesQuery';
import { Spin } from 'antd';
import BtnRegistration from '../../components/common/BtnRegistration/BtnRegistration';

const ChangingPage = () => {
  const { id: idHouse } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const registrationTypeHouse = location.state?.registrationType;
  const activeLsTypes = location.state?.activeLsTypes;
  // const arrearProviders = location.state?.arrearProviders;

  // const { data: house, isFetching: isFetchingStockHouse } =
  //   useHousingStockHouses(
  //     { houseId: idHouse, companyId: currentCompany?.id },
  //     { enabled: Boolean(idHouse && currentCompany?.id) }
  //   );

  const { data: house, isFetching: isFetchingStockHouse } =
    useHousingStockHouses({ houseId: idHouse }, { enabled: Boolean(idHouse) });

  useEffect(() => {
    if (house?.length === 1) {
      dispatch(setCurrentHouse(house[0]));
    }
  }, [house]);

  const data = {
    companyId: currentCompany?.id,
    houseId: idHouse,
    registrationType: registrationTypeHouse,
  };

  const { data: houseTemplates, isFetching } = useHouseTemplates(
    {
      serviceCompanyId: data?.companyId,
      registrationTypeId: data?.registrationType?.id,
    },
    {
      staleTime: Infinity,
      enabled: Boolean(data?.companyId && data?.registrationType),
    }
  );

  const cancellationCancel = () => {
    history.push(`/HousingStock/company/${currentCompany?.id}/houses`);
  };

  return (
    <Spin spinning={isFetchingStockHouse || isFetching}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.block}>
            <h2 className={styles.title}>Изменить режим регистрации</h2>
            <p className={styles.step}>Шаг 2/2</p>
          </div>
          <BtnRegistration text="Отменить" onClick={cancellationCancel} />
        </header>
        <FormRegisterTwo
          activeLsTypes={activeLsTypes}
          // arrearProviders={arrearProviders}
          choice={'one'}
          houseTemplates={houseTemplates}
          registrationTypeHouse={registrationTypeHouse}
        />
      </div>
    </Spin>
  );
};

export default ChangingPage;
